import classNames from 'classnames';
import IconLabel from '@/components/molecules/icon-label/icon-label';
import styles from './feature-list.module.scss';

export interface FeatureListProps {
  /** The class name to apply */
  className?: string;
  /** An array of the features to show */
  features: Content.Components['ProductDto'][];
}

const FeatureList = ({ className, features }: FeatureListProps) => {
  return (
    <div className={classNames(styles.component, className)}>
      {features.map((feature, featureIndex) => (
        <IconLabel
          key={featureIndex}
          icon={feature.productIcon as IconName}
          text={feature.name}
        />
      ))}
    </div>
  );
};

FeatureList.displayName = 'FeatureList';

export default FeatureList;
